import SiteHeader from './components/SiteHeader';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import EntrySection from './components/EntrySection';
import FeatureSection from './components/FeatureSection';
import DownloadSection from './components/DownloadSection';
import GuideSection from './components/GuideSection';
import SafetySection from './components/SafetySection';
import FaqSection from './components/FaqSection';
import ChangelogSection from './components/ChangelogSection';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full overflow-x-hidden bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <AboutSection />
        <EntrySection />
        <FeatureSection />
        <DownloadSection />
        <GuideSection />
        <SafetySection />
        <FaqSection />
        <ChangelogSection />
      </main>
      <SiteFooter />
    </div>
  );
}